import React, { useContext, useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { HeightCalculate } from "../../utils/helpers";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../utils/context/userContext";
import Requests from "../../utils/Requests/Index";
import { toast } from "react-toastify";
//import 'react-toastify/dist/ReactToastify.css'
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import "swiper/css";
import "swiper/css/navigation";
import "./style.scss";

const ProfileSlider = ({ items = [] }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { handleRefetch } = useContext(UserContext);
  const [send, setSend] = useState(false);
  const [header] = useState({
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  });
  const socket = useRef();
  const userInfo = useSelector((state) => state.user.userData);

  useEffect(() => {
    socket.current = io(`${process.env.REACT_APP_API_URL}`, {
      transports: ["websocket", "polling"],
    });
  }, []);

  // Send request
  const sendRequest = async (id) => {
    try {
      const response = await Requests.Connection.Connect(id, header);
      if (response) {
        toast.success(response.message);

        socket.current.emit("sendProposal", {
          senderId: userInfo.userID,
          name: userInfo.name,
          receiverId: id,
        });

        if (response.status) {
          setSend(true);
        }
        handleRefetch();
      }
    } catch (error) {
      if (error) console.log(error);
    }
  };

  return (
    <section className="profile-slider-section" style={{background:'#ECF9F6'}}>
      <div className="slider-header">
        <div>
          {/* <span className="tag">Testimonials</span> */}

          <h4>My Matches</h4>
        </div>

        <div className="navigation">
          <button ref={prevRef} className="prev-btn">
            ←
          </button>

          <button ref={nextRef} className="next-btn">
            →
          </button>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Autoplay]}
        loop={true}
        spaceBetween={25}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        //         breakpoints={{
        //   0: {
        //     slidesPerView: 1.2,
        //     spaceBetween: 15,
        //   },
        //   576: {
        //     slidesPerView: 2.2,
        //     spaceBetween: 20,
        //   },
        //   768: {
        //     slidesPerView: 3.2,
        //     spaceBetween: 20,
        //   },
        //   1200: {
        //     slidesPerView: 3.2,
        //     // spaceBetween: 20,
        //   },
        // }}
        breakpoints={{
          0: {
            slidesPerView: 1.2,
          },
          768: {
            slidesPerView: 2.2,
          },
          1200: {
            slidesPerView: 3.2,
          },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={item.id || index}>
            <div className="profile-card">
              <div className="profile-image">
                <img src={item?.images?.[0]?.name} alt={item?.name} />
                <button
                className="card-btn"
                style={{
                  background: "#0b8c97",
                }}
              >
                ↗
              </button>
              </div>
              

              

              <div className="overlay">
                {/* <div className="rating">★★★★★</div> */}
                <Link to={`/single-profile/${item?._id}`}>
                  <h5 className="profile_id">@{item.profileId}</h5>
                </Link>
                <Link to={`/single-profile/${item?._id}`}>
                  <h6 className="profile_name">{item?.name}</h6>
                </Link>
                <hr className="m-0" />
                <span className="card-text text-muted" style={{fontSize:'13px'}}>
                  {item?.age} Years,{" "}
                  {item?.height ? HeightCalculate(item.height) + ", " : null}{" "}
                  {item?.city ? item?.city + ", " : null}
                  {item?.birthCountry
                    ? item?.birthCountry + " (Citizen)"
                    : null}{" "}
                </span>
                {item?.professionArea && (
                  <span className="card-text text-muted" style={{fontSize:'15px'}}>
                    {" "}
                    - {item?.professionArea}{" "}
                  </span>
                )}
                {/* <br /> <br /> */}
                {!send ? (
                  <button
                    type="button"
                    className="btn shadow-sm request_btn"
                    onClick={() => sendRequest(item?._id)}
                    style={{
                      background:"#0b8c97",
                      color:'#fff'
                    }}
                  >
                    {" "}
                    Propose now{" "}
                  </button>
                ) : (
                  <small className="text-muted">Proposal send</small>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ProfileSlider;

//  <Swiper
//       modules={[Navigation, Autoplay]}
//       spaceBetween={20}
//       slidesPerView={3}
//       centeredSlides
//       loop
//       autoplay={{ delay: 3000 }}
//       onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
//       breakpoints={{
//         0: {
//           slidesPerView: 1,
//           centeredSlides: false,
//         },
//         768: {
//           slidesPerView: 2,
//           centeredSlides: false,
//         },
//         1024: {
//           slidesPerView: 3,
//           centeredSlides: true,
//         },
//       }}
//     >
//       {items.map((item, index) => (
//         <SwiperSlide key={item.id || index}>
//           <div className={`card ${index === activeIndex ? "active " : ""} border-0`}>
//             {/* <div className="d-flex "> */}
//               <img
//                 src={item?.images?.[0]?.name}
//                 alt={item?.name}
//                 className="img-fluid"
//               />

//               {index === activeIndex && (
//                 <div className="details">
//                   <h4>{item?.name}</h4>
//                   <p>{item?.professionArea}</p>
//                 </div>
//               )}
//             {/* </div> */}
//           </div>
//         </SwiperSlide>
//       ))}
//     </Swiper>
